<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import singleImage from 'dashboard/assets/images/nucleo-welcome.png';
import SalesPropertyReferenceField from './SalesPropertyReferenceField.vue';

defineProps({
  profile: { type: Object, required: true },
  errors: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
</script>

<template>
  <LaisCard
    density="flush"
    class="self-start !border-0 !shadow-sm"
    data-test="sales-property-identity-section"
  >
    <div
      class="self-start p-8 font-roboto max-[700px]:p-8"
      data-test="sales-property-identity-card-content"
    >
      <div
        class="flex justify-between gap-6 max-[700px]:block"
        data-test="sales-property-identity-layout"
      >
        <div data-test="sales-property-identity-content">
          <h2
            class="mb-2 font-lato text-[32px] font-bold leading-[39px] text-[#464F53] max-[700px]:text-[24px] max-[700px]:leading-[29px]"
          >
            {{ t('SALES_PROPERTY.IDENTITY.GREETING') }}
          </h2>
          <p
            class="mb-[22px] w-[52vw] text-xl leading-6 text-[#464F53] max-[700px]:mb-[44px] max-[700px]:w-full"
            data-test="sales-property-identity-description"
          >
            {{ t('SALES_PROPERTY.IDENTITY.DESCRIPTION') }}
          </p>
          <div
            class="mb-[44px] w-full max-w-[440px]"
            data-test="sales-property-identity-field"
          >
            <SalesPropertyReferenceField
              :filled="Boolean(profile.codigo)"
              disabled
              :error="errors.codigo"
              :label="t('SALES_PROPERTY.IDENTITY.LABEL')"
              for-id="sales-property-identity-code"
            >
              <input
                id="sales-property-identity-code"
                :value="profile.codigo"
                disabled
                :placeholder="t('SALES_PROPERTY.IDENTITY.PLACEHOLDER')"
                class="h-8 w-full border-0 border-b border-[#A7B7BE] bg-transparent px-0 text-base font-bold text-[#7F8C93] outline-none"
                data-test="sales-property-identity-code"
              />
            </SalesPropertyReferenceField>
          </div>
        </div>
        <img
          :src="singleImage"
          alt=""
          class="hidden h-[14vw] w-[11vw] shrink-0 pt-[0.5vw] min-[1025px]:block"
          data-test="sales-property-identity-image"
        />
      </div>
      <slot name="footer" />
    </div>
  </LaisCard>
</template>
